import { createCommonSelectors } from '../../../../util/store';
import { getEmptyESState } from '../../../../ngrx/state';
import { GITLAB_COMPANY_PL } from '../../../../constants';
import { ESGitlabCompany, GitlabCompany } from '../../models/git-company';

import * as gitlabCompany from './gitlab-company.actions';
import { createSelector } from 'reselect';
import { prop } from '../../../../../helpers';

export interface State extends ESGitlabCompany {
  isLoading: boolean;
}

const initialState: State = {
  ...getEmptyESState<GitlabCompany>(),
  isLoading: true
};

export function reducer(state = initialState, action: gitlabCompany.Actions): State {
  switch (action.type) {
    case gitlabCompany.GET_INDEX: {
      return { ...state, isLoading: true };
    }

    case gitlabCompany.GET_INDEX_FAIL:
    case gitlabCompany.GET_INDEX_COMPLETE: {
      return { ...state, isLoading: false };
    }

    case gitlabCompany.CLEAR_SETTINGS:
    case gitlabCompany.REMOVE_ALL_COMPLETE: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}

export const { getState, getEntities, getIds, getAll, isEmpty } = createCommonSelectors<GitlabCompany, State>(
  GITLAB_COMPANY_PL
);

export const getFirstId = createSelector(getIds, ids => ids[0]);
export const isLoading = createSelector(getState, prop('isLoading'));

export const isFirstLoading = createSelector(isEmpty, isLoading, (e, l) => l && e);
